// extracted by mini-css-extract-plugin
module.exports = {"description":"index_description_23iGa","item":"index_item_2ClJE","itemLabel":"index_itemLabel_1Leij"};